import React from 'react';
import { Field } from 'redux-form'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentRemove from 'material-ui/svg-icons/content/remove';
import MenuItem from 'material-ui/MenuItem';

import FormAutoComplete2 from './FormAutoComplete2'
import FormSelect from './FormSelect'
import FormText from './FormText'
import FormDatePicker from './FormDatePicker'

import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons';

const moment = require('moment');

class FormBizHolidayContents extends  React.Component {

  render() {

    const {
      fields,
      minDate,
      maxDate,
      dialogMonth,
      onRemoveDate
    } = this.props

    const dateYesterday = new Date();
    dateYesterday.setDate(dateYesterday.getDate() - 1);
  
    return (
      <div style={{marginBottom: 20}}>

        <div className="row">

          {fields.map((name, index) => {

            return (
              <div className="col-12" key={index}>
                <div className="row">
                  <div className="col-3">
                    <Field 
                    key={index}
                    name={`${name}.date`} 
                    component={FormDatePicker} 
                    label="日付" style={{ width: '100%' }} 
                    textFieldStyle={{width: '100%'}} 
                    dialogMonth={dialogMonth} 
                    minDate={minDate}
                    maxDate={maxDate}
                    disableYearSelection
                    showWeek/>
                  </div>
                  <div className="col-2">

                    <Field
                      name={`${name}.kind`}
                      component={FormSelect}
                      style={{ width: '100%' }}
                      label="休日/出勤"
                    >
                      <MenuItem value={1} primaryText={'休日'} />
                      <MenuItem value={2} primaryText={'出勤'} />
                    </Field>

                  </div>

                  <div className="col-2">

                    <Field
                      name={`${name}.holidayKind`}
                      component={FormSelect}
                      style={{ width: '100%' }}
                      label="休日種別"
                    >
                      <MenuItem value={0} primaryText={''} />
                      <MenuItem value={1} primaryText={'法定'} />
                      <MenuItem value={2} primaryText={'所定'} />
                    </Field>

                  </div>

                  <div className="col-4">
                    <Field name={`${name}.comment`} component={FormText} label="備考" style={{ width: '100%' }} />
                  </div>

                  <div className="col-1">
                    <div style={{ display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '100%', paddingTop: '5px' }}>
                      <FloatingActionButton zDepth={0}
                        mini={true}
                        backgroundColor={colors.red300}
                      //iconStyle={{fill: blue300}}>
                        onClick={() => {
                          fields.remove(index)
                          // onRemoveDate(dialogMonth.getMonth() + 1, index, fields)
                        }}
                      >
                        <ContentRemove />
                      </FloatingActionButton>
                    </div>

                  </div>
                </div>
            </div>
            )

          })}

        </div>

        <div className="row">

          <div className="col-12" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} 
              onClick={() => {
                fields.push({})
              }}>
              <ContentAdd />
            </FloatingActionButton>
          </div>
        </div>

      </div>

    )

  }

}

export default FormBizHolidayContents


// WEBPACK FOOTER //
// ./src/components/FormBizHolidayContents.js